import React from 'react';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { Box, Button, Drawer, IconButton, Typography } from '@mui/material';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import CloseIcon from '@mui/icons-material/Close';
import { useAppDispatch, useAppSelector } from 'app/store';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useDeleteOTPMutation } from 'entities/sendOTP/api';

type DeleteOtpDrawerPropsType = {
  id: number;
};

type FormDataType = {
  id: number;
};
export const DeleteOtpDrawer = ({ id }: DeleteOtpDrawerPropsType) => {
  const dispatch = useAppDispatch();
  const { isDrawerOpen } = useAppSelector((state) => state.ui);
  const [deleteOtpRequest] = useDeleteOTPMutation();
  const { handleSubmit } = useForm<FormDataType>();

  const onSubmit: SubmitHandler<FormDataType> = () => {
    deleteOtpRequest({ id }).then(() => {
      dispatch(setDrawerOpen(false));
    });
  };

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={() => dispatch(setDrawerOpen(false))}
    >
      <DrawerContent>
        <div className="header">
          <Typography
            variant="h5"
            sx={{ fontWeight: '600' }}
          >
            Удалить способ отправки
          </Typography>
          <IconButton
            onClick={() => dispatch(setDrawerOpen(false))}
            sx={{ color: '#000' }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className="content">
          <div>
            <div style={{ marginBottom: '20px' }}>Вы действительно хотите способ отправки?</div>
          </div>

          <Box
            sx={{
              display: 'flex',
              marginTop: '30px',
            }}
          >
            <Button
              color="error"
              variant="contained"
              sx={{ textTransform: 'none' }}
              onClick={handleSubmit(onSubmit)}
            >
              Да, удалить
            </Button>
          </Box>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
